import { ExtraLogoOption } from "./add-heating-fee-order-dialog";

export interface StorageBalanceInput {
  /** logo.inStorage as the API reports it (with the ledger on: NAV count minus open draws). */
  inStorage: number | undefined | null;
  /** Delivery quantity of this logo already in the cart (designs + standalone lines). */
  cartDelivery: number;
  /** The extra quantity chosen in this dialog. */
  extraQty: number;
  option: ExtraLogoOption;
}

export interface StorageBalance {
  inStorage: number;
  /** What this order will draw from storage: min(delivery, available). */
  used: number;
  /** In storage after this order is placed - the number the design page shows next. */
  after: number;
  /** Extra sent TO storage; it only counts once NAV ships (production), so it is shown separately. */
  addedAtShipment: number;
}

/**
 * The card's arithmetic, kept pure so it can be tested (case 20006106: "always the same
 * and correct stock"). Mirrors the order-build rule: only DELIVERY quantities draw from
 * storage (fromStorage = min(deliveryQty, available)); storage quantities are production
 * TO storage and never reduce the balance. Returns null when there is nothing in storage.
 */
export function computeStorageBalance(a: StorageBalanceInput): StorageBalance | null {
  const inStorage = Math.max(0, a.inStorage ?? 0);
  if (inStorage === 0) return null;
  const extraToDelivery = a.option === "toDelivery" ? Math.max(0, a.extraQty) : 0;
  const addedAtShipment = a.option === "toStorage" ? Math.max(0, a.extraQty) : 0;
  const used = Math.min(Math.max(0, a.cartDelivery) + extraToDelivery, inStorage);
  return { inStorage, used, after: inStorage - used, addedAtShipment };
}
